import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { Messages } from '~src/codegen/Localize';
import { ExplorableItemDefinition, ContentTypeFilterClause } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { Subscriptions } from '~src/dda/resources/Subscriptions';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { SubscriptionContentType } from '~src/ts/models/ContentTypes';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const SubscriptionDefinition: ExplorableItemDefinition = {
  itemType: 'subscription',
  pluralName: Messages.subscriptions,
  singularName: Messages.subscription,
  emptyStateMessage: Messages.subscriptionsEmptyMessage,
  contentFilterKeys: SubscriptionContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: ServerFilterClauses.ContentType(['subscription']) as ContentTypeFilterClause,
  getBasicQuery: () => {
    return Subscriptions.all().withExtraParams(SubscriptionContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
